<template>
  <div>
    <v-select
      :items="estateType"
      v-model="instance.typeOfEstate"
      label="Type de bien"
    ></v-select>
    <v-layout row>
      <v-flex xs6 class="pr-2">
        <v-text-field
          v-model="instance.surfacemin"
          label="Surface"
          suffix="m²"
          v-validate="'numeric'"
          data-vv-name="surfacemin"
          :error-messages="errors.collect('surfacemin')"
        ></v-text-field>
      </v-flex>
      <v-flex xs6 class="pl-2">
        <v-text-field
          v-model="instance.numberOfRoom"
          label="Nombre minimum de pièces"
          v-validate="'numeric'"
          data-vv-name="numberOfRoom"
          :error-messages="errors.collect('numberOfRoom')"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <v-text-field
          v-model="instance.budget"
          label="Loyer max"
          suffix="€"
          v-validate="'numeric'"
          data-vv-name="budget"
          :error-messages="errors.collect('budget')"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 class="mb-2">
        <v-alert :value="instance.budget > 100" type="info">
          Pour un loyer de ce montant, vos revenus mensuels doivent être
          supérieurs à {{ targetIncomes }}€
        </v-alert>
      </v-flex>
    </v-layout>

    <v-layout row>
      <v-flex :class="{ xs7: !isNew, xs12: isNew }">
        <v-textarea
          v-model="instance.descEstate"
          label="Décrivez votre bien idéal"
        />
      </v-flex>
      <v-flex
        xs5
        class="mt-2 ml-1"
        style="color: grey; font-size: .8rem"
        v-if="!isNew"
      >
        <h4>Notre feedback</h4>
        <p>
          {{
            instance.descEstateAdmin ||
              "Nous n'avons rien renseigné pour l'instant"
          }}
        </p>
      </v-flex>
    </v-layout>

    <v-layout row>
      <v-flex :class="{ xs7: !isNew, xs12: isNew }">
        <v-textarea
          v-model="instance.futurNeighborhood"
          label="Décrivez votre futur quartier"
          data-vv-name="futurNeighborhood"
          :error-messages="errors.collect('futurNeighborhood')"
        >
        </v-textarea>
      </v-flex>
      <v-flex
        xs5
        class="mt-2 ml-1"
        style="color: grey; font-size: .8rem"
        v-if="!isNew"
      >
        <h4>Notre feedback</h4>
        <p>
          {{
            instance.futurNeighborhoodAdmin ||
              "Nous n'avons rien renseigné pour l'instant"
          }}
        </p>
      </v-flex>
    </v-layout>

    <div class="h6">
      Pour répondre au mieux à votre demande, classez de 1 à 3 le plus important
      pour vous : localisation, prix, ou la superficie
    </div>
    <v-select
      label="Critère 1"
      :items="criteria"
      v-model="instance.criterion1"
    />
    <v-select
      label="Critère 2"
      :items="criteria"
      v-model="instance.criterion2"
    />
    <v-select
      label="Critère 3"
      :items="criteria"
      v-model="instance.criterion3"
    />
  </div>
</template>

<script>
import { ESTATE_TYPE } from "../../data/DefaultSettings";
export default {
  name: "ProjectHost",
  props: { value: {}, project: {}, isNew: {} },
  components: {},
  mounted() {
    if (this.project != null) {
      const {
        typeOfEstate,
        surfacemin,
        budget,
        numberOfRoom,
        descEstate,
        futurNeighborhood,
        criterion1,
        criterion2,
        criterion3,
        descEstateAdmin,
        futurNeighborhoodAdmin
      } = this.project;
      this.instance = {
        typeOfEstate,
        surfacemin,
        budget,
        numberOfRoom,
        descEstate,
        futurNeighborhood,
        criterion1,
        criterion2,
        criterion3,
        descEstateAdmin,
        futurNeighborhoodAdmin
      };
    }
    this.send();
  },
  data() {
    return {
      criteria: ["Localisation", "Prix", "Superficie"],
      instance: {
        typeOfEstate: "apartment",
        surfacemin: "",
        budget: "",
        numberOfRoom: "",
        descEstate: "",
        futurNeighborhood: "",
        criterion1: "",
        criterion2: "",
        criterion3: ""
      },
      map: {
        url: "http://{s}.tile.osm.org/{z}/{x}/{y}.png"
      },

      timer: null
    };
  },
  computed: {
    estateType() {
      return ESTATE_TYPE;
    },
    targetIncomes() {
      return Math.floor(this.instance.budget * 3);
    }
  },
  methods: {
    async send() {
      await this.$validator.validate();
      this.$emit("input", { ...this.instance });
    }
  },
  watch: {
    instance: {
      deep: true,
      async handler() {
        this.send();
      }
    }
  }
};
</script>

<style scoped></style>
